document.addEventListener('DOMContentLoaded', function () {
    const blockHeroSecondary = document.querySelectorAll('.block-hero-secondary');

    if (blockHeroSecondary.length === 0) return;

    blockHeroSecondary.forEach(function (blockHeroSecondary) {
        setupBlockHeroSecondaryFullscreen(blockHeroSecondary);
        setupBlockHeroSecondaryHighlights(blockHeroSecondary);
    });
});

function setupBlockHeroSecondaryHighlights(blockHeroSecondary) {
    const blockHeroSecondaryHighlights = blockHeroSecondary.querySelector('.block-hero-secondary__highlights');

    if (!blockHeroSecondaryHighlights) return;

    const updateBlockHeroSecondaryHighlightHeaders = function () {
        const blockHeroSecondaryHighlightHeaders = blockHeroSecondaryHighlights.querySelectorAll('.block-hero-secondary__highlight-header');
        const blockHeroSecondaryHighlightHeadings = blockHeroSecondaryHighlights.querySelectorAll('.block-hero-secondary__highlight-heading');
        const blockHeroSecondaryHighlightContents = blockHeroSecondaryHighlights.querySelectorAll('.block-hero-secondary__highlight-content');
        let blockHeroSecondaryHighlightHeaderHeight = 0;
        let blockHeroSecondaryHighlightHeadingHeight = 0;
        let blockHeroSecondaryHighlightContentHeight = 0;

        blockHeroSecondaryHighlights.style.removeProperty('--highlight-header-height');
        blockHeroSecondaryHighlights.style.removeProperty('--highlight-heading-height');
        blockHeroSecondaryHighlights.style.removeProperty('--highlight-content-height');

        blockHeroSecondaryHighlightHeaders.forEach(function (blockHeroSecondaryHighlightHeader) {
            blockHeroSecondaryHighlightHeaderHeight = Math.max(
                blockHeroSecondaryHighlightHeaderHeight,
                blockHeroSecondaryHighlightHeader.offsetHeight
            );
        });

        blockHeroSecondaryHighlightHeadings.forEach(function (blockHeroSecondaryHighlightHeading) {
            blockHeroSecondaryHighlightHeadingHeight = Math.max(
                blockHeroSecondaryHighlightHeadingHeight,
                blockHeroSecondaryHighlightHeading.offsetHeight
            );
        });

        blockHeroSecondaryHighlightContents.forEach(function (blockHeroSecondaryHighlightContent) {
            blockHeroSecondaryHighlightContentHeight = Math.max(
                blockHeroSecondaryHighlightContentHeight,
                blockHeroSecondaryHighlightContent.offsetHeight
            );
        });

        if (blockHeroSecondaryHighlightHeaderHeight > 0) {
            blockHeroSecondaryHighlights.style.setProperty('--highlight-header-height', blockHeroSecondaryHighlightHeaderHeight + 'px');
        }

        if (blockHeroSecondaryHighlightHeadingHeight > 0) {
            blockHeroSecondaryHighlights.style.setProperty('--highlight-heading-height', blockHeroSecondaryHighlightHeadingHeight + 'px');
        }

        if (blockHeroSecondaryHighlightContentHeight > 0) {
            blockHeroSecondaryHighlights.style.setProperty('--highlight-content-height', blockHeroSecondaryHighlightContentHeight + 'px');
        }
    };

    updateBlockHeroSecondaryHighlightHeaders();
    window.addEventListener('resize', updateBlockHeroSecondaryHighlightHeaders, { passive: true });
    window.addEventListener('load', updateBlockHeroSecondaryHighlightHeaders, { once: true });

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateBlockHeroSecondaryHighlightHeaders);
    }

    blockHeroSecondaryHighlights.querySelectorAll('img').forEach(function (blockHeroSecondaryHighlightImage) {
        blockHeroSecondaryHighlightImage.addEventListener('load', updateBlockHeroSecondaryHighlightHeaders, { once: true });
    });
}

function setupBlockHeroSecondaryFullscreen(blockHeroSecondary) {
    const blockHeroSecondaryOpenButton = blockHeroSecondary.querySelector('[data-hero-secondary-fullscreen-open]');
    const blockHeroSecondaryModal = blockHeroSecondary.querySelector('[data-hero-secondary-fullscreen]');

    if (!blockHeroSecondaryOpenButton || !blockHeroSecondaryModal) return;

    const blockHeroSecondaryCloseButtons = blockHeroSecondaryModal.querySelectorAll('[data-hero-secondary-fullscreen-close]');
    const blockHeroSecondaryModalVideo = blockHeroSecondaryModal.querySelector('video');

    const closeBlockHeroSecondaryModal = function () {
        blockHeroSecondary.classList.remove('block-hero-secondary--fullscreen-open');
        blockHeroSecondaryModal.setAttribute('aria-hidden', 'true');
        blockHeroSecondaryOpenButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('has-modal-open');

        if (blockHeroSecondaryModalVideo) {
            blockHeroSecondaryModalVideo.pause();
        }

        blockHeroSecondaryOpenButton.focus();
    };

    const openBlockHeroSecondaryModal = function () {
        blockHeroSecondary.classList.add('block-hero-secondary--fullscreen-open');
        blockHeroSecondaryModal.setAttribute('aria-hidden', 'false');
        blockHeroSecondaryOpenButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('has-modal-open');

        if (blockHeroSecondaryModalVideo) {
            blockHeroSecondaryModalVideo.play().catch(function () {});
        }

        const blockHeroSecondaryCloseButton = blockHeroSecondaryModal.querySelector('.block-hero-secondary__fullscreen-close');
        if (blockHeroSecondaryCloseButton) {
            blockHeroSecondaryCloseButton.focus();
        }
    };

    blockHeroSecondaryOpenButton.addEventListener('click', openBlockHeroSecondaryModal);

    blockHeroSecondaryCloseButtons.forEach(function (blockHeroSecondaryCloseButton) {
        blockHeroSecondaryCloseButton.addEventListener('click', closeBlockHeroSecondaryModal);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !blockHeroSecondary.classList.contains('block-hero-secondary--fullscreen-open')) return;

        closeBlockHeroSecondaryModal();
    });
}
